/**
  * Add recaptcha to any form or anywhere. See RecaptchaValidationService
  * for site key and validation moethods.
  *
  * Usage: <div data-sw-recaptcha="{{ recaptchaSiteKey }}"></div>
  *
  */

var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-recaptcha]').each(function() {
    var $el = $(this);
    var siteKey = $el.data('swRecaptcha');
    var modelId = 'recaptchaModel';

    require(['js/lib/models/ModelManager', 'js/lib/views/RecaptchaView'], function(ModelManager, RecaptchaView) {

      ModelManager.amdNewModelInstance(modelId, function(model) {
        var options = {
          el: $el,
          siteKey: siteKey,
          model: model
        };
        new RecaptchaView(options);
      });
    });

  });

};
